import { useTranslation } from 'react-i18next';
import { Search } from '@parrot-software/design-system/icons';

/**
 * ReportEmptyState - Empty state component for reports
 *
 * Displays a user-friendly message with an icon when no data is available.
 * Shows a primary message and optional secondary message with action button.
 *
 * @returns {React.ReactElement} Empty state component
 *
 * @example
 * <ReportEmptyState />
 */
export const ReportEmptyState = () => {
  const { t } = useTranslation(['reports']);

  const primaryMessage = t('reportCommon:messages.noInformation');
  const secondaryMessage = t('reportCommon:messages.noInformationChangeFilters');

  return (
    <div className="flex flex-col items-center justify-center gap-4 p-6 text-center" data-testid="report-empty-state">
      <Search className="h-9 w-9 text-primary" strokeWidth={1.5} />

      <div>
        <p className="text-lg font-medium mb-1">{primaryMessage}</p>
        <p className="text-sm text-muted-foreground w-64">{secondaryMessage}</p>
      </div>
    </div>
  );
};
